import React from 'react';
import FilterForm from './FilterForm';

const FilterMenu = ({ workerFilter, handleSearchChange, setDropdownVisible, moduleType = 'dashboard-workers' }) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <FilterForm
        showWorkerFilter={false} // We only want project filtering here
        handleSearchChange={handleSearchChange}
        setDropdownVisible={setDropdownVisible}
        moduleType={moduleType}
      />
    </div>
  );
};

export default FilterMenu;
